module.exports = __webpack_public_path__ + "img/kongCar.f328acb9.png";